import { ModelMixin } from '../core/base-generic.model';

export class ImportIntegrationConnection extends ModelMixin<ImportIntegrationConnection>() {
    protected static _type = 'connection';

    protected static _resource = 'integration/connection/:integrationId';

    protected static _version = 'v2';

    get url(): string {
        return this._attributes['url'];
    }

    get integrationId(): number {
        return this._attributes['integrationId'];
    }
}
